module Meevo.Components.Controls {
    "use strict";
    interface IPaymentAccountUpdateScope extends angular.IScope {
        model: Model.PaymentAccount;
    }
    export class CreditPaymentAccountUpdate implements angular.IDirective {
        constructor(
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            private busyService: Meevo.Components.Busy.IBusyService,
            private modalService: Meevo.Components.Modal.IModalService
        ) {
        }

        restrict = "E";
        require = "ngModel";
        templateUrl = "app/components/controls/paymentAccounts/creditPaymentAccountUpdate.template.html";
        scope = {
            model: "=ngModel",
        };

        updateModel(scope: IPaymentAccountUpdateScope, ngModel, response) {
            scope.model.creditCardLastFour = response.creditCardLastFour;
            scope.model.creditCardExpirationDate = response.creditCardExpirationDate;
            scope.model.zipCode = response.zipCode
            scope.model.id = response.id;
            ngModel.$validate();
        }

        private merchantAccountsSupportingUpdate: Model.MerchantAccountProviderEnum[] = [Model.MerchantAccountProviderEnum.Worldpay];

        link = (scope: IPaymentAccountUpdateScope, element: JQuery, attr: angular.IAttributes, ngModel) => {

            scope.canRefreshPaymentAccount = (): boolean => {
                return scope.model.merchantProviderId === Model.MerchantAccountProviderEnum.Worldpay &&
                    scope.model.merchantAccountObjectState === Model.ObjectStateEnum.Active;
            }

            scope.allowUpdatePaymentAccountFromProcessor = (): boolean => {
                return !scope.model.isQueuedForAutoUpdate;
            }

            scope.getPaymentAccountRefreshTooltip = (): string => {
                return scope.allowUpdatePaymentAccountFromProcessor() ?
                    'TOOLTIP_PAYMENT_ACCOUNT_CHECK_FOR_UPDATE' :
                    'TOOLTIP_PAYMENT_ACCOUNT_QUEUED_FOR_UPDATE';
            }

            scope.updatePaymentAccountFromProcessor = (): void => {

                if (!scope.allowUpdatePaymentAccountFromProcessor()) {
                    return;
                }

                this.busyService.start();
                this.dataService.customMethodData(`api/PaymentAccount/${scope.model.id}/ExternalUpdateRequest`, 'POST', {})
                    .then((response) => {

                        this.busyService.stop();

                        if (response.data.errorResponseMessageKey) {
                            this.modalService.alert(response.data.errorResponseMessageKey);
                            return;
                        }

                        if (!response.data.paymentAccount) {

                            let messageKey: string;
                            let modalOptions: Meevo.Components.Modal.ILocalOptions;

                            if (scope.model.isAccountUpdaterEnabled) {
                                messageKey = 'PAYMENT_ACCOUNT_NO_EXTERNAL_UPDATE';

                                modalOptions = {
                                    okButtonContentKey: 'LABEL_YES',
                                    cancelButtonContentKey: 'LABEL_NO',
                                    showCancelButton: true
                                }
                            } else {
                                messageKey = 'PAYMENT_ACCOUNT_NO_EXTERNAL_UPDATE_UPDATER_NOT_ENABLED';

                                modalOptions = {
                                    okButtonContentKey: 'LABEL_OK'
                                }
                            }

                            this.modalService.info(messageKey, Modal.ModalTranslationModes.Translate, false, modalOptions).then((update) => {
                                if (update && scope.model.isAccountUpdaterEnabled) {
                                    this.busyService.start();
                                    this.dataService.customMethodData(`api/PaymentAccount/${scope.model.id}/AutoUpdateRequest`, 'POST', null)
                                        .then(() => scope.model.isQueuedForAutoUpdate = true)
                                        .finally(() => this.busyService.stop());
                                }
                            });
                            return;
                        }

                        angular.extend(scope.model, response.data.paymentAccount);
                    });
            }
        };

        static factory(): angular.IDirectiveFactory {
            let directive = (dataService,busyService, modalService) => {
                return new CreditPaymentAccountUpdate(dataService, busyService, modalService);
            };

            directive.$inject = [
                "meevo.components.common.DataService",
                "meevo.components.busy.BusyService",
                "meevo.components.modal.ModalService"
            ];

            return directive;
        }
    }

    angular.module("meevo.components.controls")
        .directive("meevoCreditPaymentAccountUpdate", CreditPaymentAccountUpdate.factory());
}